import { useActiveLang } from "./use-active-lang";
import { isDefaultLang } from "@shapeable/utils";
export var useIsDefaultLangActive = function () {
  var lang = useActiveLang();
  return isDefaultLang(lang);
};